import api from "./api";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const EMPTY_ESTABLISHMENT_FILTERS = Object.freeze({
  type: "",
  status: "",
});

export function compactEstablishmentFilters(filters = {}) {
  const params = {};
  ["type", "status"].forEach((key) => {
    const value = String(filters[key] ?? "").trim();
    if (value) params[key] = value;
  });
  return params;
}

function normalizedFilterKey(raw) {
  return String(raw ?? "")
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("fr");
}

function uniqueValues(values = []) {
  const seen = new Set();
  return (Array.isArray(values) ? values : []).reduce((result, raw) => {
    const value = String(raw ?? "").trim();
    const key = normalizedFilterKey(value);
    if (!value || seen.has(key)) return result;
    seen.add(key);
    result.push(value);
    return result;
  }, []);
}

export function establishmentTypeOptions(t, values = []) {
  return [
    { id: "", text: t ? t("establishments.filter.all_types", "Tous les types") : "Tous les types" },
    ...uniqueValues(values).map((value) => ({ id: value, text: value })),
  ];
}

export function establishmentStatusOptions(t, values = []) {
  return [
    { id: "", text: t ? t("establishments.filter.all_statuses", "Tous les statuts") : "Tous les statuts" },
    ...uniqueValues(values).map((value) => ({ id: value, text: value })),
  ];
}

export function buildEstablishmentFilterOptionParams(filters = {}) {
  const params = {};
  ["provinceId", "departmentId", "subPrefectureId"].forEach((key) => {
    const value = Number(filters[key]);
    if (Number.isFinite(value) && value > 0) params[key] = value;
  });
  return params;
}

export function parseEstablishmentFilterOptions(data) {
  return {
    types: uniqueValues(data?.types ?? data?.Types),
    statuses: uniqueValues(data?.statuses ?? data?.Statuses),
  };
}

function establishmentField(row, keys) {
  for (const key of keys) {
    const value = String(row?.[key] ?? "").trim();
    if (value) return value;
  }
  return "";
}

export function establishmentTypeValue(row) {
  return establishmentField(row, [
    "type",
    "Type",
    "establishmentType",
    "EstablishmentType",
    "estType",
    "EstType",
  ]);
}

export function establishmentStatusValue(row) {
  return establishmentField(row, [
    "status",
    "Status",
    "establishmentStatus",
    "EstablishmentStatus",
    "estStatus",
    "EstStatus",
  ]);
}

export function deriveEstablishmentFilterValues(rows = []) {
  return {
    types: uniqueValues((Array.isArray(rows) ? rows : []).map(establishmentTypeValue)),
    statuses: uniqueValues((Array.isArray(rows) ? rows : []).map(establishmentStatusValue)),
  };
}

export function filterEstablishmentRows(rows = [], filters = {}) {
  const type = normalizedFilterKey(filters.type);
  const status = normalizedFilterKey(filters.status);
  return (Array.isArray(rows) ? rows : []).filter(
    (row) =>
      (!type || normalizedFilterKey(establishmentTypeValue(row)) === type) &&
      (!status || normalizedFilterKey(establishmentStatusValue(row)) === status)
  );
}

export async function fetchEstablishmentFilterOptions(filters = {}, signal) {
  const { data } = await api.get("/Assignment/establishment-filter-options", {
    params: buildEstablishmentFilterOptionParams(filters),
    headers: authHeaders(),
    signal,
  });
  return parseEstablishmentFilterOptions(data);
}

export function buildAssignmentEstablishmentParams(sptid, filters = {}) {
  return {
    sptid,
    ...compactEstablishmentFilters(filters),
  };
}

export function buildAssignmentCreationEntries(values, forceReassignment) {
  return [
    ["AsignId", values.teachers],
    ["EstabId", values.establishment],
    ["AssigDateTime", values.date],
    ["ForceReassignment", String(forceReassignment)],
  ];
}
